package horcrux.frontend.common.views.collections

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.components.input.InstructionsWithHelp
import horcrux.frontend.common.views.documents.DocumentNavigator
import mui.material.Container
import mui.system.PropsWithSx
import mui.system.sx
import react.FC

external interface ManageDocumentCollectionProps : PropsWithSx {
    var globalAppState: GlobalAppState
}

val ManageDocumentCollection = FC<ManageDocumentCollectionProps> { props ->
    props.globalAppState.currentCollectionMetadataMaybeState.get()?.let {
        Container {
            this.sx { +props.sx }
            if (props.globalAppState.documentMetadataListState.get().isEmpty()) {
                EmptyCollectionMessage {}
            } else {
                InstructionsWithHelp {
                    this.id = "document-management-instructions"
                    this.instructions = "Explore and Manage the Documents in This Collection"
                    this.helpText =
                        """You can explore and manage the documents in this collection below.""".trimIndent()
                }
            }
        }

        DocumentNavigator {
            this.documentMetadataListState = props.globalAppState.documentMetadataListState
            this.documentMetadataFilter = { it.isRootDocument }
            this.globalAppState = props.globalAppState
        }
    }
}
